// import { Menu, MenuItem, ListItemIcon, ListItemText, SvgIconProps } from "@mui/material";
// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// export interface MenuItemConfig {
//   icon: React.ComponentType<SvgIconProps> | React.ReactElement;
//   label: string;
//   onClick?: (row: any) => void;
//   permission?: boolean | ((row: any) => boolean);
//   color?: "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning" | string;
//   link?: string | ((row: any) => string);
//   textColor?: string;
// }

// interface DynamicMenuItemProps {
//   row: any;
//   menuItems: MenuItemConfig[];
// }

// export const DynamicMenuItem = ({
//   row,
//   menuItems,
// }: DynamicMenuItemProps) => {
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const open = Boolean(anchorEl);
//   const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
//     event.stopPropagation();
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   // Filter menu items based on permission (default to true if not specified)
//   const visibleMenuItems = menuItems.filter((item) => {
//     if (item.permission === undefined) return true;
//     if (typeof item.permission === 'function') {
//       return item.permission(row);
//     }
//     return item.permission !== false;
//   });

//   return (
//     <>
//       <button
//         onClick={handleClick}
//         style={{
//           background: "none",
//           border: "none",
//           padding: 0,
//           cursor: "pointer",
//         }}
//       >
//         <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
//       </button>

//       <Menu
//         anchorEl={anchorEl}
//         open={open}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//         PaperProps={{ 
//           elevation: 3,
//           sx: { 
//             fontFamily: 'var(--bs-font-sans-serif) !important',
//             '& *': {
//               fontFamily: 'var(--bs-font-sans-serif) !important'
//             },
//             '& .MuiMenuItem-root': {
//               minHeight: '28px',
//               padding: '4px 12px'
//             },
//             '& .MuiMenuItem-root .MuiListItemText-primary': {
//               fontSize: '13px !important',
//               fontWeight: '500 !important'
//             }
//           }
//         }}
//       >
//         {visibleMenuItems.map((item, index) => {
//           const icon = item.icon;
//           const linkTo = typeof item.link === 'function' ? item.link(row) : item.link;
//           const iconColor = item.color || "inherit";
          
//           // Determine if this is a valid MUI color or a custom color string
//           const isValidMuiColor = ["inherit", "primary", "secondary", "error", "info", "success", "warning"].includes(iconColor);
          
//           // Render icon appropriately
//           const renderIcon = () => {
//             if (React.isValidElement(icon)) {
//               return icon;
//             } else {
//               const IconComponent = icon as React.ComponentType<SvgIconProps>;
//               return (
//                 <IconComponent 
//                   fontSize="small" 
//                   color={isValidMuiColor ? iconColor as any : undefined}
//                   sx={!isValidMuiColor && iconColor ? { color: iconColor } : undefined}
//                 />
//               );
//             }
//           };
          
//           const menuItemContent = (
//             <>
//               <ListItemIcon>
//                 {renderIcon()}
//               </ListItemIcon>
//               <ListItemText 
//                 primary={item.label}
//                 sx={{ 
//                   fontFamily: 'var(--bs-font-sans-serif) !important', 
//                   fontSize: '13px',
//                   ...(item.textColor && { color: item.textColor })
//                 }} 
//               />
//             </>
//           );

//           const menuItemProps: any = {
//             onClick: () => {
//               if (item.onClick) {
//                 item.onClick(row);
//               }
//               handleClose();
//             },
//             ...(item.textColor && { sx: { color: item.textColor } }),
//           };

//           // If link is provided, wrap with Link component
//           if (linkTo) {
//             return (
//               <MenuItem
//                 key={index}
//                 component={Link}
//                 to={linkTo}
//                 onClick={handleClose}
//                 {...(item.textColor && { sx: { color: item.textColor } })}
//               >
//                 {menuItemContent}
//               </MenuItem>
//             );
//           }

//           return (
//             <MenuItem key={index} {...menuItemProps}>
//               {menuItemContent}
//             </MenuItem>
//           );
//         })}
//       </Menu>
//     </>
//   );
// };










import { Menu, MenuItem, ListItemIcon, ListItemText, SvgIconProps } from "@mui/material";
import Colors from "Constants/Color";
import React, { useState } from "react";
import { Link } from "react-router-dom";

export interface MenuItemConfig {
  icon: React.ComponentType<SvgIconProps> | React.ReactElement;
  label: string;
  onClick?: (row: any) => void;
  permission?: boolean | ((row: any) => boolean);
  color?: "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning" | string;
  link?: string | ((row: any) => string);
  textColor?: string;
}

interface DynamicMenuItemProps {
  row: any;
  menuItems: MenuItemConfig[];
}

export const DynamicMenuItem = ({ row, menuItems }: DynamicMenuItemProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  // Filter menu items based on permission
  const visibleMenuItems = menuItems.filter((item) => {
    if (item.permission === undefined) return true;
    if (typeof item.permission === "function") return item.permission(row);
    return item.permission !== false;
  });

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 3,
          sx: {
            fontFamily: 'var(--bs-font-sans-serif) !important',
            "& *": { fontFamily: 'var(--bs-font-sans-serif) !important' },
            "& .MuiMenuItem-root": { minHeight: "28px", padding: "4px 12px" },
            "& .MuiMenuItem-root .MuiListItemText-primary": {
              fontSize: "13px !important",
              fontWeight: "500 !important",
            },
          },
        }}
      >
        {visibleMenuItems.map((item, index) => {
          const icon = item.icon;
          const linkTo = typeof item.link === "function" ? item.link(row) : item.link;

          /** COLOR HANDLING */
          let iconColor = item.color || "inherit";

          // Convert `themeColor` → HEX color
          if (iconColor === "themeColor") {
            iconColor = Colors?.themeBgColor;
          }

          const isValidMuiColor = [
            "inherit",
            "primary",
            "secondary",
            "error",
            "info",
            "success",
            "warning",
          ].includes(iconColor);

          // Render icon
          const renderIcon = () => {
            if (React.isValidElement(icon)) return icon;

            const IconComponent = icon as React.ComponentType<SvgIconProps>;
            return (
              <IconComponent
                fontSize="small"
                color={isValidMuiColor ? (iconColor as any) : undefined}
                sx={!isValidMuiColor && iconColor ? { color: iconColor } : undefined}
              />
            );
          };

          const menuItemContent = (
            <>
              <ListItemIcon>{renderIcon()}</ListItemIcon>
              <ListItemText
                primary={item.label}
                sx={{
                  fontFamily: "var(--bs-font-sans-serif) !important",
                  fontSize: "13px",
                  ...(item.textColor && { color: item.textColor }),
                }}
              />
            </>
          );

          // General props
          const menuItemProps: any = {
            onClick: () => {
              if (item.onClick) item.onClick(row);
              handleClose();
            },
            ...(item.textColor && { sx: { color: item.textColor } }),
          };

          // Wrap link if provided
          if (linkTo) {
            return (
              <MenuItem
                key={index}
                component={Link}
                to={linkTo}
                onClick={handleClose}
                {...(item.textColor && { sx: { color: item.textColor } })}
              >
                {menuItemContent}
              </MenuItem>
            );
          }

          return (
            <MenuItem key={index} {...menuItemProps}>
              {menuItemContent}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
